<template>
  <div class="school_design">
    <!-- 轮播图 -->
    <div class="swiper">
      <el-carousel height="400px" arrow="never">
        <el-carousel-item v-for="item in banner" :key="item.id">
          <router-link v-if="item.link" to="item.link">
            <img :src="item.coverPath" alt="">
          </router-link>
          <img :src="item.coverPath" alt="" v-else>
          <!-- <h3 class="small">{{ item }}</h3> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 内容 -->
    <div class="schoolDesign_content">
      <!-- 国际大师 -->
      <div class="international_master">
        <!-- 标题 -->
        <div class="title">
          <h1>课程详情</h1>
        </div>
        <!-- 列表信息 -->
        <div class="schoolDesign_box">
          <ul v-if="international_master_list.length">
            <template v-for="(item,index) in international_master_list">
              <master_item :key="index" :itemObj="item"/>
            </template>
          </ul>
          <div class="no_list" v-else></div>
           <div class="page_box">
            <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
          </div>
        </div>
        <!-- 更多按钮 -->
        <!-- <div class="more_btn">
          <el-button @click="MoreInternationalMaster">
            <div>MORE+</div>
            <div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </el-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import master_item from "@/components/list_item/master_item";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    master_item,
    myPage
  },
  data(){
    return{
      international_master_list:[],     //国际大师列表
      banner:[],       //轮播图列表
       layerpageinfo: {
        pageSize: 12,
        pageNo: 0,
        total: 0
      },
    }
  },
  created() {
    // 获取设计学院列表
    this.getFrontColleges()
    // 轮播图
    this.getBanner()
  },
  methods: {
    // 获取轮播图
    getBanner(){
      let params = {
        type: 'GranderViewCarousel',
        class_one: 'GranderViewCarouselCollege',
        pageNo: 0,
        pageSize: 10,
        sort: 'SortDefault'
      }
      this.api.getNews(params).then(res=>{
        if (res.error.err_code !== 0) return;
        this.banner = res.obj.list;
      })
    },
    // 更多
    MoreInternationalMaster() {
      this.$router.push({
        name: "school_design_detail"
      });
    },
    // 获取设计学院列表
    getFrontColleges(){
       let obj = Object.assign({}, this.layerpageinfo);
      this.api.getFrontColleges(obj)
      .then(res => {
        if(res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.international_master_list = list.length ? list : [];
         this.layerpageinfo.total = res.obj.totalSize;
      })
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontColleges();
    },
  }
};
</script>

<style lang="scss">
.school_design {
  background-color: #fff;
  .swiper {
    background: #DBDFE2;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .schoolDesign_content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;
    // 设计任务
    .international_master {
      // 标题
      h3.master_h3 {
        font-size: 34px;
        color: $font-black;
        line-height: 114px;
        padding-top: 30px;
      }
      // 列表信息
      .schoolDesign_box {
        width: 100%;
        ul {
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
}
</style>